import React, { useEffect } from "react";
import { v4 } from "uuid";

const SampleEmbeddedForm = () => {
  useEffect(() => {
    let sessionInfoLocal = localStorage.getItem("sessionInfo");
    if (!sessionInfoLocal) {
      sessionInfoLocal = v4();
      localStorage.setItem("sessionInfo", sessionInfoLocal);
    }

    const script = document.createElement("script");
    script.id = "boloforms-embed-script";
    script.src =
      "https://appscript-scripts.s3.ap-south-1.amazonaws.com/boloforms-embed-index.min.js";
    script.async = true;
    script.onload = () => {
      if (document.querySelector("#embed-container").childElementCount > 0)
        return;

      // Create an instance of BoloFormsEmbed once the script is loaded
      const embed = new BoloFormsEmbed({
        containerId: "embed-container",
        token: "prod_emb_0338c78c-0169-4a05-b3ce-437988794b80",
        iframeOpts: { width: "100%", height: "600px" },
        sessionInfo: sessionInfoLocal,
      });
    };
    document.body.appendChild(script);

    // used in start-taking-signature : to redirect to dashboard registration page
    window.addEventListener("message", (event) => {
      if (event.data.redirectTo) {
        window.location.href = event.data.redirectTo;
      }
    });

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="embed-container" />;
};

export default SampleEmbeddedForm;
